module.exports = __webpack_public_path__ + "static/TangleTower0-c96df8e95f8cf2b03788d4ff03e7c50e.png";